import {initWebComponent} from "@/helpers/web-component-helper";
import {initHideButton} from "@/helpers/layer/info/layer-info-helper";
import {clearPrintSelectLayerItems, printMap} from "@/helpers/print/print-helper";
import {startLadda, stopLadda} from "@/helpers/ladda-helper";
import {initPrint, printAddRectangle} from "@/helpers/print/print-scales-helper";
import {
    getBySelector,
    hideElementsBySelector,
    setValueBySelector
} from "@/helpers/element-helper";
import $ from "jquery";
import {getActiveLayers, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {getFilterLayerName} from "@/helpers/filter/filter-helper";
import {getAreSegmentsVisible} from "@/helpers/tools/tools-measure-helper";
import {getGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper.js";

export class BookmarkPrintComponent extends HTMLElement {
    constructor(){
        super();

        const printScales = window.printScales

        let areSettingsVisible = 'd-none'

        let hasFilterGeometry = 'd-none'
        if(getLayerByName(getFilterLayerName(), false)) {
            hasFilterGeometry = ''
            areSettingsVisible = ''
        }

        let isSegmentsActive = 'd-none'
        let isSegmentsChecked = ''
        if(getAreSegmentsVisible() &&
            (
                window.measurePrintFeatures.length > 0 ||
                (
                    window.drawMeasureVectorSource &&
                    window.drawMeasureVectorSource.getFeatures().length > 0
                )
            )
        ) {
            isSegmentsActive = ''
            isSegmentsChecked = 'checked="checked"'
            areSettingsVisible = ''
        }

        const template = document.createElement('template');
        let innerHTML = `
<div class="card m-3 bg-lighter" style="border-radius: 10px;">
     <div class="card-header font-weight-bold p-2">
        <h2>
         <span class="fa fa-file-pdf navbar-icon" style="font-size:15px"></span>
        <layout-language data-key="openPrint"></layout-language>
         <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
            <span class="fa fa-times"></span>
         </button>
         </h2>
     </div>`


        if(printScales) {

            let template
            let scales

        innerHTML += `   
         <div class="card-body p-2" style="max-height: calc(100vh - 174px);overflow: hidden auto;">`

            if(printScales.apps.length > 1) {
                innerHTML += `   
            <div class="form-group">
             <label class="form-label">Template</label>
             <select class="custom-select" id="slcPrintTemplate">`

                printScales.apps.map((layout, key) => {
                    innerHTML += '<option>' + layout + '</option>'
                    if (key === 0) {
                        template = layout
                    }
                })

                innerHTML +=
                    `</select>
            </div>`
            }

            innerHTML += `
            <div class="form-group">
             <label class="form-label">Layout</label>
              <select class="custom-select" id="slcPrintLayout">`

            printScales.layouts.map( (layout, key) => {
                innerHTML +=  '<option>' + layout.name + '</option>'
                if(key === 0) {
                    scales = layout.scales
                }
            })

         let activeLayout = printScales.layouts[0]

         if(!activeLayout.attributes.find(attribute => attribute.name === 'Schaal')) {
            console.log('dont send with request')
         }

        innerHTML += `</select>
            </div> 
            <div class="form-group">
             <label class="form-label">Schaal</label>
             
                <div class="input-group input-group-lg">
                  <div class="input-group-prepend">
                    <span class="input-group-text border-bottom-0">1:</span>
                  </div>
                 <select class="form-control" id="slcPrintScale">`
            scales.map( scale => {
                innerHTML += '<option value="' + scale.value + '">' + scale.value + '</option>'
            })

            innerHTML += `</select>
                </div>
            </div><div id="divPrintAttributes">`


            activeLayout.attributes.map( attribute => {
                if(attribute.type	=== 'String' && attribute.name !== 'kv_website_name' && attribute.name !== 'Schaal') {
                    innerHTML += `
                <div class="form-group">
                    <label class="form-label">${attribute.name}</label>
                    <input type="text" class="form-control iptPrintAttributes" data-name="${attribute.name}" value="${attribute.default}">
                </div>`
                }
            })

         innerHTML += `
           </div>
            <div class="form-group mt-2 d-none">
             <label class="form-label">Legenda's</label>
             <div id="divPrintLegends"></div>
             <hr>
            </div> 
            <div class="form-group mt-2 ${areSettingsVisible}">
               <label class="form-label">Instellingen</label>
                <label class="custom-control custom-checkbox ${isSegmentsActive}" id="divPrintSegments">
                   <input type="checkbox" class="custom-control-input" ${isSegmentsChecked} id="chbPrintSegments">
                   <span class="custom-control-label">Neem maatvoering mee</span>
                </label>
                  <label class="custom-control custom-checkbox ${hasFilterGeometry}" id="divPrintFilterCounter">
                   <input type="checkbox" class="custom-control-input" id="chbPrintFilterCounter">
                   <span class="custom-control-label">Neem filter contour mee</span>
                </label>
            </div>

            <div id="divPrintSelectLayer" >
              <div class="row">
                <div class="col">
                     <label class="form-label">Kies een laag om objecten in de print te markeren</label>
                    <select size="1" class="form-control" id="slcPrintSelectLayer">
                            <option value="">Kies mijn laag</option>
                            
                             `

                getActiveLayers().map(layer => {
                    // Niet mogelijk maken om eigen laag te selecteren
                    // Moet wel mogelijk zijn voor een eigen buffer //  && layer.ID !== activeFilter.BookmarkPresentationID
                    if(layer && layer.Type === 'WMS') {
                        innerHTML += `<option value="${layer.ID}">${layer.DisplayName}</option>`
                    }
                })

                innerHTML +=  `  
                    </select>
                </div>
            </div>`


            innerHTML +=  `<div id="divPrintSelectLayerItems"></div>`


    if(window.settings.MapFishGrid) {
        innerHTML +=
            `
            <div class="form-group mt-2">
                  <label class="custom-control custom-checkbox">
                   <input type="checkbox" class="custom-control-input" id="chbPrintGrid">
                   <span class="custom-control-label">Grid</span>
                </label>
            </div>
            <hr>`
    }

         innerHTML += `
            <div class="form-group">
             <label class="form-label">Bestandsnaam</label>
              <input type="text" class="form-control" id="iptPrintFileName" value="">
            </div> 
            <div class="form-group mt-2">
                <label class="form-label">Maak afdruk als:</label>
            </div>
            <div class="row mt-2">
                <div class="col-6">
                    <button class="btn btn-outline-secondary btn-block btn-sm ladda-button" data-spinner-color="#858380" id="btnPrintCreatePDF">PDF</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-outline-secondary btn-block btn-sm ladda-button" data-spinner-color="#858380" id="btnPrintCreatePNG">PNG</button>
                </div>
            </div>
            <div class="form-row mt-2">
                <a target="print" class="btn btn-outline-success btn-block btn-sm d-none" id="btnPrintDownloadPDF">Download afdruk</a>
            </div>
         </div>`
        }

        innerHTML += `</div>`;

        template.innerHTML = innerHTML
        initWebComponent(this, template)

        $('#slcPrintScale').select2({
            dropdownAutoWidth: false,
            closeOnSelect: true,
            tags: true,
        }).on('select2:select', function (e) {
            printAddRectangle()
            hideElementsBySelector('#btnPrintDownloadPDF')
        }).on('select2:open', function(e) {
            $('input.select2-search__field').prop('placeholder', 'Selecteer een schaal of vul een eigen schaal in');
        });

        $('#slcPrintLayout').select2({
            dropdownAutoWidth: false,
            closeOnSelect: true,
        }).on('select2:select', function (e) {
            let html = ''

            window.printLayout = printScales.layouts.find(layout => layout.name === e.params.data.id)
            window.printLayout.attributes.map( attribute => {
                if(attribute.type === 'String' && attribute.name !== 'kv_website_name' && attribute.name !== 'Schaal') {
                    html += `
                <div class="form-group">
                    <label class="form-label">${attribute.name}</label>
                    <input type="text" class="form-control iptPrintAttributes" data-name="${attribute.name}" value="${attribute.default}">
                </div>`
                }
            })

            $('#divPrintAttributes').html(html)
            printAddRectangle()
            hideElementsBySelector('#btnPrintDownloadPDF')
        }).on('select2:open', function(e) {
            $('input.select2-search__field').prop('placeholder', 'Selecteer een layout');
        });


        if(window.printTemplate) {
            setValueBySelector('#slcPrintTemplate', window.printTemplate)
        }

        const divPrintLegends = getBySelector('#divPrintLegends')

        if(divPrintLegends) {
            window.printLegends = []
            divPrintLegends.addEventListener('change', (e) => {
                const bookmarkPresentationID = parseInt(e.target.dataset.bookmarkPresentationId)
                if(e.target.checked) {
                    if(!window.printLegends.includes(bookmarkPresentationID)) {
                        window.printLegends.push(bookmarkPresentationID)
                    }
                } else {
                    window.printLegends = window.printLegends.filter( id => id !== bookmarkPresentationID)
                }
            })
        }

        if(printScales) {
            this.querySelectorAll('#slcPrintTemplate, #slcPrintLayout').forEach(element => {
                element.addEventListener('change', (e) => {
                    hideElementsBySelector('#btnPrintDownloadPDF')
                    if(e.target.id === 'slcPrintTemplate') {

                        initPrint(e.target.value)
                    } else {
                        printAddRectangle()
                    }
                })
            })
            this.querySelector('#btnPrintCreatePDF').addEventListener('click', () => {
                stopLadda()
                hideElementsBySelector('#btnPrintDownloadPDF')
                printMap('pdf')
                startLadda('#btnPrintCreatePDF')
            })
            this.querySelector('#btnPrintCreatePNG').addEventListener('click', () => {
                stopLadda()
                hideElementsBySelector('#btnPrintDownloadPDF')
                printMap('png')
                startLadda('#btnPrintCreatePNG')
            })


            this.querySelector('#slcPrintSelectLayer').addEventListener('change', (e) => {

                const value = e.target.value
                let innerHtml = ''

                clearPrintSelectLayerItems()

                if(value) {
                    let featureId
                    getGeoJsonLayers().map(layer => {
                        if(window.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === parseInt(value))?.features[0]?.featureInfo.find(featureInfo => parseInt(featureInfo.FormID) === parseInt(layer.get('name').replace('activeGeoJson-', '').replace('-0', ''))) ) {
                            featureId = layer.getSource()?.getFeatures()[0]?.getId()
                        }
                    })

                    if (featureId) {
                        innerHtml = `  
                    <div class="card card-hover-secondary mt-2">    
                        <div class="card-header bg-lighter p-1">
                            ${featureId}
                        </div>
                    </div>`
                    }
                }

                getBySelector('#divPrintSelectLayerItems').innerHTML = innerHtml
            })
            initHideButton()
        }
    }
}
